var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3762 23.2822C19.2894 23.2698 19.1778 23.2698 19.0786 23.2822C16.8962 23.2078 15.1602 21.4222 15.1602 19.2274C15.1602 16.983 16.9706 15.1602 19.2274 15.1602C21.4718 15.1602 23.2946 16.983 23.2946 19.2274C23.2822 21.4222 21.5586 23.2078 19.3762 23.2822Z",
    stroke: "#8A96A3",
    strokeWidth: 2.48,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.08 32.2712C23.3574 33.8486 21.0736 34.8067 18.5576 34.8067C16.0415 34.8067 13.7577 33.8486 12.0352 32.2712C12.1319 31.3616 12.7126 30.4713 13.748 29.7745C16.3996 28.0133 20.7349 28.0133 23.3671 29.7745C24.4026 30.4713 24.9832 31.3616 25.08 32.2712Z",
    stroke: "#8A96A3",
    strokeWidth: 2.48,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 35C28.0604 35 35 28.0604 35 19.5C35 10.9396 28.0604 4 19.5 4C10.9396 4 4 10.9396 4 19.5C4 28.0604 10.9396 35 19.5 35Z",
    stroke: "#8A96A3",
    strokeWidth: 2.48,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.b9f3d7869d1604da8a95e873a71dc120.svg";
export { ForwardRef as ReactComponent };